import React from "react";
import { Button, Paper, Typography } from "@mui/material";
import { Link } from "react-router";
import { getCaseLink } from "../../../services/productService";
import { AbstractCase } from "../../../types/Entities/AbstractCase";
import { ArrowForward } from "@mui/icons-material";
import ProductBox from "@/src/components/ProductBox/ProductBox";

type DivorcePlannerBoxProps = {
  product: AbstractCase;
};

const DivorcePlannerBox = ({ product }: DivorcePlannerBoxProps) => {
  if (product.isInitialProxy) {
    return null;
  }

  return (
    <ProductBox headline={"Scheidungsplaner"}>
      <Typography sx={{ marginBottom: "1rem" }}>
        Ihr persönlicher Scheidungsplaner passt sich über den gesamten Zeitraum der Scheidung immer an Ihre aktuelle Situation an. So haben Sie die nächsten
        Schritte im Blick und können Ihre Checklisten erledigen.
      </Typography>
      <Button color={"primary"} component={Link} to={getCaseLink(product) + "/scheidungsplaner"} endIcon={<ArrowForward />} sx={{ paddingLeft: 0 }}>
        Zum Scheidungsplaner
      </Button>
    </ProductBox>
  );
};

export default DivorcePlannerBox;
